import type { ContextValues } from "@atoms/atom-types";
import { useMemo } from "react";
import { useFrontendProvision } from "./FrontendProvisionProvider";
import { useDebugSettings } from "./hooks/useDebugSettings";
import { useExtraContext } from "./hooks/useExtraContext";

// Stable empty object to avoid creating new references
const EMPTY_CONTEXT: ContextValues = {};

export const useCombinedContext = (
  evenMoreExtraContext: ContextValues = EMPTY_CONTEXT,
): ContextValues => {
  const provision = useFrontendProvision();
  const atomContext = provision.getContextHook?.();
  const extraContext = useExtraContext();
  const { enableDataLogging } = useDebugSettings();

  return useMemo(
    () => ({
      ...(atomContext ?? {}),
      ...(extraContext ?? {}),
      ...(evenMoreExtraContext ?? {}),
      // Use string "true" instead of boolean to avoid backend toLowerCase error
      ...(enableDataLogging
        ? ({ debug: "true" } as unknown as ContextValues)
        : {}),
    }),
    [atomContext, extraContext, evenMoreExtraContext, enableDataLogging],
  );
};
